import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  wrapper: {
    background: "#fff",
    position: "absolute",
    borderBottom: "0.5px solid rgb(204, 204, 204)",
    borderTop: "0.5px solid rgb(204, 204, 204)",
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    bottom: "104px",
    //left: '100%',
    transform: "translateY(80%)",
    zIndex: 3,
    "&.error": {
      boxShadow: "inset 0px 0px 5px rgba(255,0,0,0.5)",
      "&::after": {
        boxShadow: "inset -5px 0px 5px 2px rgba(255,0,0,0.2)",
      },
    },
    "&::after": {
      display: "block",
      content: '""',
      position: "absolute",
      right: 0,
      top: 0,
      height: "100%",
      width: "20px",
      background: "#fff",
    },
  },
  textfield: {
    height: "auto",
    outline: "none",
    userSelect: "text",
    wordBreak: "break-word",
    lineHeight: "1.5rem",
    overflow: "auto",
    resize: "none",
    border: "none",
    letterSpacing: "0.01875rem",
    borderRadius: "0 important!",
    "& .MuiOutlinedInput-multiline": {
      padding: 0,
      "& textarea": {
        boxSizing: "border-box",
        padding: "0.575rem 110px 0.575rem 0.575rem",
        fontSize: "0.925rem",
        lineHeight: 1.2,
        fontWeight: 300,
        maxHeight: "72px !important",
      },
    },
    "& fieldset": {
      display: "none !important",
    },
    //bottom: '145px',
    //opacity: 0,
  },
  popup: {
    background: "#fff",
    position: "absolute",
    zIndex: 5,
    transform: "translateY(-100%)",
    top: "-12px",
    left: "12px",
    width: "320px",
    height: "auto",
    maxHeight: "260px",
    boxShadow: "0 0 5px rgba(74, 74, 74, 0.5)",
    borderRadius: "4px",
  },
  shortcut: {
    padding: "7px 10px",
    fontSize: "14px",
    lineHeight: "18px",
    borderBottom: "1px solid rgba(204, 204, 204, 0.2)",
    opacity: "0.8",
    cursor: "pointer",

    "&::last-child": {
      borderBottom: "none",
    },
    // '&:hover': {
    //   background: '#f5f5f5',
    // },
    "&.focus": {
      background: "#f5f5f5",
    },
  },
  back_drop: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
  },

  in_view: { position: "absolute", bottom: "10px" },
  send_btn_wrapper: {
    zIndex: 4,
    position: "absolute",
    right: "5px",
    bottom: "7px",
  },
  hash: {
    textAlign: "center",
    lineHeight: "28px",
    fontSize: "20px",
    fontWeight: 600,
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    marginRight: "5px",
    transition: "all ease 0.4s",
    cursor: "pointer",
    "&:hover": {
      background: "#f5f5f5",
      boxShadow: "0 0 3px #ddd",
      transition: "all ease 0.4s",
    },
  },
}));
